import { cn } from "@/lib/utils";
import { CircularLoader } from "./CircularLoading";

export type LoadingProps = {
    className?: string;
}

export default function Loading({ className }: LoadingProps) {
    return <div className={cn(' w-full h-full flex items-center justify-center', className)}><CircularLoader /></div>;
}